import { CommonModule } from '@angular/common';
import { Component, OnInit, isDevMode } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from '../../services/error-handler.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  currentApplicationVersion = environment.appVersion;
  public resetPasswordError: string | undefined = undefined;
  resetPasswordForm!: FormGroup;
  resetPasswordButton = "reset-button button-disabled";
  errorCreatePasswordMsg = false;
  errorConfirmPasswordMsg = false
  resetPasswordScreen = true;
  username = '';
  email='';
  token='';
  pageComponentName = 'ResetPassword';
  isDevMode: boolean = false;

  constructor(private fb: FormBuilder, private activeroute: ActivatedRoute, private apiService: ApiService, private router: Router, private errorHandler: ErrorHandlerService ) { 
    this.isDevMode = isDevMode();
  }

  ngOnInit(): void {
    this.resetPasswordForm = this.fb.group({
      'createPassword': [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)])],
      'confirmPassword': [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)])]
    });
  }

  goToPage(pageName:string){
    this.router.navigate([`${pageName}`]);
  }

  enableButton(createPassword: any, confirmPassword: any) {
    if (createPassword === confirmPassword && createPassword != "" && confirmPassword != "") {
      this.resetPasswordButton = 'reset-button button-enable';
    }
    else {
      this.resetPasswordButton = 'reset-button button-disabled';
    }
  }

  handlePasswordChange(event: any): void {
    this.resetPasswordForm.value.createPassword = event.target.value;
    if (this.resetPasswordForm.value.createPassword.length > 5 && this.resetPasswordForm.value.createPassword.length < 30 ) {
      this.errorCreatePasswordMsg = false;
    } else {
      this.errorCreatePasswordMsg = true;
    }
  }

  handleConfirmPasswordChange(event: any): void {
    this.resetPasswordForm.value.confirmPassword = event.target.value;
    if (this.resetPasswordForm.value.createPassword === this.resetPasswordForm.value.confirmPassword) {
      this.errorConfirmPasswordMsg = false;
    } else {
      this.errorConfirmPasswordMsg = true;
    }
    this.enableButton(this.resetPasswordForm.value.createPassword, this.resetPasswordForm.value.confirmPassword);
  }


  resetPassword(){
    this.resetPasswordError = '';
    const value = this.resetPasswordForm.value
    this.activeroute.queryParams.subscribe(params => {
      this.token = params['token'];
    });
    this.apiService.writeValue('put','/resetpassword', {'token':this.token,'password':value.confirmPassword} )
    .subscribe({
      next: (v) => {
        if(this.isDevMode) console.log("Next :", v);
        if(this.isDevMode) console.log("Password reset successful");
        this.resetPasswordScreen = false;
        
      },
      error: (err: HttpErrorResponse) => {
        this.errorHandler.handleError(err);
        this.resetPasswordError = this.errorHandler.errorMessage;
        this.resetPasswordScreen = true;
      }
    });    
  }
  

}
